import { Phone, CalendarDays } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

export default function MobileBottomCTA() {
  const { t } = useLanguage();

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 safe-area-bottom safe-area-x shadow-lg">
      <div className="grid grid-cols-2 divide-x divide-gray-200 dark:divide-gray-700">
        {/* Call Button */}
        <a
          href="tel:+4989987654"
          className="flex items-center justify-center gap-2 py-4 text-primary-600 dark:text-primary-400 font-medium active:bg-gray-100 dark:active:bg-gray-800 transition-colors min-h-[56px]"
        >
          <Phone className="w-5 h-5" />
          <span>{t('header.call')}</span>
        </a>

        {/* Reserve Button */}
        <Link
          to="/reservation"
          className="flex items-center justify-center gap-2 py-4 bg-accent-500 text-white font-medium active:bg-accent-600 transition-colors min-h-[56px]"
        >
          <CalendarDays className="w-5 h-5" />
          <span>{t('nav.reservation')}</span>
        </Link>
      </div>
    </div>
  );
}
